/* Viretta – »Gør den til et sæt« in the cart drawer (snippets/viretta-cart-set-swap.liquid).
   »Skift til sættet«: one /cart/update.js call – the line out, the set in (same quantity) – then the drawer redraws
   through the theme's own cart:refresh. The old line is kept in sessionStorage so the swapped line can offer »Fortryd«,
   which makes the same call the other way round. */
(() => {
  if (window.VirettaCartSetSwap) return;
  window.VirettaCartSetSwap = true;

  const KEY = 'viretta-set-swap';
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const readSwap = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
  const writeSwap = (value) => { try { value ? sessionStorage.setItem(KEY, JSON.stringify(value)) : sessionStorage.removeItem(KEY); } catch (e) { /* storage blocked */ } };
  const refreshCart = () => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  const updateCart = (updates) =>
    fetch(`${root()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    }).then((response) => { if (!response.ok) throw new Error('cart update failed'); return response.json(); });

  /* Swap */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-set-swap-to]');
    if (!button) return;
    const box = button.closest('[data-viretta-set-swap]');
    if (!box || button.getAttribute('aria-busy') === 'true') return;

    const setId = button.dataset.setSwapTo;
    const quantity = Number(box.dataset.lineQuantity) || 1;
    button.setAttribute('aria-busy', 'true');
    updateCart({ [box.dataset.lineKey]: 0, [setId]: quantity })
      .then(() => {
        writeSwap({ fromVariant: box.dataset.lineVariant, fromTitle: box.dataset.lineTitle, quantity, setVariant: setId });
        refreshCart();
      })
      .catch(() => { button.removeAttribute('aria-busy'); });
  });

  /* Undo */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-set-swap-undo]');
    if (!link) return;
    const swap = readSwap();
    if (!swap) return;
    link.setAttribute('aria-busy', 'true');
    fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const setLine = cart.items.find((item) => String(item.variant_id) === String(swap.setVariant));
        const updates = { [swap.fromVariant]: swap.quantity };
        if (setLine) updates[setLine.key] = Math.max(0, setLine.quantity - swap.quantity);
        return updateCart(updates);
      })
      .then(() => { writeSwap(null); refreshCart(); })
      .catch(() => link.removeAttribute('aria-busy'));
  });

  /* After every redraw: put »… er skiftet ud med sættet · Fortryd« on the set line, as long as that line is there */
  const markSwappedLine = () => {
    const swap = readSwap();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const line = swap && Array.from(drawer.querySelectorAll('line-item, .line-item')).find((item) =>
      item.querySelector(`a[href*="variant=${swap.setVariant}"], [data-variant-id="${swap.setVariant}"]`)
    );
    /* Only touch the page when something is missing or wrong – this runs from a MutationObserver */
    drawer.querySelectorAll('.viretta-set-swap-undo').forEach((note) => { if (!line || !line.contains(note)) note.remove(); });
    if (!line || line.querySelector('.viretta-set-swap-undo')) return;
    const note = document.createElement('p');
    note.className = 'viretta-set-swap-undo';
    note.append(`${swap.fromTitle || 'Der Artikel'} wurde durch das Set ersetzt · `);
    const undo = document.createElement('button');
    undo.type = 'button';
    undo.className = 'viretta-set-swap-undo__link';
    undo.dataset.setSwapUndo = '';
    undo.textContent = 'Rückgängig';
    note.append(undo);
    (line.querySelector('.line-item__info, .v-stack') || line).append(note);
  };

  /* Arrows: one tile at a time */
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-set-swap-prev], [data-set-swap-next]');
    if (!arrow) return;
    const track = arrow.closest('[data-viretta-set-swap]')?.querySelector('[data-set-swap-track]');
    const tile = track?.querySelector('.viretta-set-swap__tile');
    if (!track || !tile) return;
    const step = tile.getBoundingClientRect().width + 10;
    track.scrollBy({ left: arrow.hasAttribute('data-set-swap-next') ? step : -step, behavior: 'smooth' });
  });

  let timer;
  new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(markSwappedLine, 50); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markSwappedLine); else markSwappedLine();
})();
